module.exports = __webpack_public_path__ + "static/media/attachedIcon.34c0f9bc.svg";